import * as React from "react";
import {Modal} from "semantic-ui-react";
import {FC} from "react";

export const StorageModal: FC = () =>  {
    let showStorageString = new URLSearchParams(location.search).get("showStorage");
    let storage = JSON.parse(showStorageString || "false");
    if(!storage) {
        return <div/>;
    }

    let storageContent = {};
    Object.keys(localStorage).forEach((key) => {
        storageContent[key] = localStorage.getItem(key);
    })

    return (
        <Modal open={true}>
            <Modal.Header>Storage Content</Modal.Header>
            <Modal.Content>
                {JSON.stringify(storageContent)}
            </Modal.Content>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/StorageModal.tsx